
const functions = {

    fadeOutLogo() {
        const logoLink = document.querySelector('.logo-link');
        if(logoLink) {
            const svgIcon = logoLink.querySelector('svg');
            if (svgIcon) {
                const textSystemhaus = svgIcon.querySelector('.logo-text-systemhaus');
                if (textSystemhaus) {
                    textSystemhaus.classList.remove('initial-state-left');
                    textSystemhaus.classList.add('animate-to-left');
                }
                const textSolutions = svgIcon.querySelector('.logo-text-solutions');
                if (textSolutions) {
                    textSolutions.classList.remove('initial-state-right');
                    textSolutions.classList.add('animate-to-right');
                }
                logoLink.classList.add('small');
            }
        }
    },

    fadeInLogo() {
        const logoLink = document.querySelector('.logo-link');
        if(logoLink) {
            logoLink.classList.remove('small');
            const svgIcon = logoLink.querySelector('svg');
            if (svgIcon) {
                const textSystemhaus = svgIcon.querySelector('.logo-text-systemhaus');
                if (textSystemhaus) {
                    textSystemhaus.classList.remove('animate-to-left');
                    textSystemhaus.classList.add('initial-state-left', 'animate-from-left');
                }
                const textSolutions = svgIcon.querySelector('.logo-text-solutions');
                if (textSolutions) {
                    textSolutions.classList.remove('animate-to-right');
                    textSolutions.classList.add('initial-state-right', 'animate-from-right');
                }
            }
        }
    }

};


export default functions;